import { isThinkingFailed } from './thinkingState.js';
import { hasAuthoritativeWorkflowState, workflowProjection } from './workflowRunProjectionState.js';

export const isRegenerableTimelineItem = (entry, resolveThinkingFailed = isThinkingFailed) => [
  [workflowProjection(entry).recovery?.action === 'retry_save',
    workflowProjection(entry).recovery?.available === true].every(Boolean),
  [entry?.type === 'message', entry?.role === 'assistant'].every(Boolean),
  [
    entry?.type === 'thinking',
    resolveThinkingFailed(entry),
    !hasAuthoritativeWorkflowState(entry),
  ].every(Boolean),
].some(Boolean);
